/**
 * 表单校验规则工具
 */

const PHONE_REGEX = /^1[3-9]\d{9}$/;
const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** 判断是否为手机号 */
export const isPhone = (value: string) => !!value && PHONE_REGEX.test(value.trim());

/** 判断是否为邮箱 */
export const isEmail = (value: string) => !!value && EMAIL_REGEX.test(value.trim());

/**
 * 手机号校验规则
 */
export const phoneValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入手机号'));
  }
  if (!PHONE_REGEX.test(value)) {
    return Promise.reject(new Error('请输入有效的手机号'));
  }
  return Promise.resolve();
};

/**
 * 邮箱校验规则
 */
export const emailValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入邮箱'));
  }
  if (!EMAIL_REGEX.test(value)) {
    return Promise.reject(new Error('请输入有效的邮箱地址'));
  }
  return Promise.resolve();
};

/**
 * 手机号或邮箱校验规则
 */
export const phoneOrEmailValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入手机号或邮箱'));
  }
  if (!PHONE_REGEX.test(value) && !EMAIL_REGEX.test(value)) {
    return Promise.reject(new Error('请输入有效的手机号或邮箱'));
  }
  return Promise.resolve();
};

/**
 * 密码校验规则（6-20位字母+数字）
 */
export const passwordValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入密码'));
  }
  if (value.length < 6 || value.length > 20) {
    return Promise.reject(new Error('密码长度为6-20位'));
  }
  const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/;
  if (!passwordRegex.test(value)) {
    return Promise.reject(new Error('密码必须包含字母和数字'));
  }
  return Promise.resolve();
};

/**
 * 验证码校验规则（6位数字）
 */
export const codeValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入验证码'));
  }
  const codeRegex = /^\d{6}$/;
  if (!codeRegex.test(value)) {
    return Promise.reject(new Error('验证码为6位数字'));
  }
  return Promise.resolve();
};

/**
 * 用户名校验规则（3-20 位，字母、数字、下划线、中文）
 */
export const usernameValidator = (_: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入用户名'));
  }
  const v = value.trim();
  if (v.length < 3 || v.length > 20) {
    return Promise.reject(new Error('用户名为3-20个字符'));
  }
  if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]+$/.test(v)) {
    return Promise.reject(new Error('用户名仅支持字母、数字、下划线和中文'));
  }
  return Promise.resolve();
};

/**
 * 确认密码校验规则
 */
export const confirmPasswordValidator = (passwordField: string = 'password') => {
  return ({ getFieldValue }: any) => ({
    validator(_: any, value: string) {
      if (!value || getFieldValue(passwordField) === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('两次输入的密码不一致'));
    },
  });
};
